import { createFileRoute } from "@tanstack/react-router";
import { ModuleGuard } from "@/components/auth/ModuleGuard";
import WhatsAppHistoryPage from "@/pages/WhatsAppHistoryPage";

export const Route = createFileRoute("/_app/whatsapp-history")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ModuleGuard module="contacts">
      <WhatsAppHistoryPage />
    </ModuleGuard>
  );
}
